module.exports = __webpack_public_path__ + "img/ywcj-gyljr_ysgh.a609ae42.png";